import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS, 
	GET_PROJECT_QA_WELDING_INSPECTION,
	CREATE_PROJECT_QA_WELDING_INSPECTION,
	UPDATE_PROJECT_QA_WELDING_INSPECTION,
	DESTROY_PROJECT_QA_WELDING_INSPECTION,
} from "./actions"

export function ProjectQaWeldingInspectionsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTION}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTION}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTION}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTION}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsReducer } from "modules/project/qa/welding_inspections/reducer"

// project_qa_welding_inspections:ProjectQaWeldingInspectionsReducer,
